export const bezierCurves = {
  easeOutQuart: [0.25, 1, 0.5, 1],
} as const
